<template>
    <div id="div_odontograma" 
        class="odontograma"
    >
        <div class="vertical"></div>
        <div class="horizontal"></div>

        <!-- preenche os quadrantes da ESQ pra DIR, de CIMA pra BAIXO -->
        <div v-for="quadrante in quadrantesArray(tipoDenticao)"  
            :key="quadrante"
            v-bind="{
                id    : 'q' + quadrante,
                style : { 
                    justifyContent   : ((quadrante % 2) == 0) ? 'start' : 'end',
                    gridTemplateRows : (tipoDenticao == gConsts.denticao.PERMANTENTE) ? 'auto auto' : 'auto auto auto auto'
                }
            }"            
            class="quadrante"
        >
            <div v-for="dente in children.filter(node => denteInQuadrante(parseInt(node.layout.label, 10), quadrante))"
                :key="dente.layout.label"
                @click.stop="handleClick(dente)"
                v-bind="{
                    id         : dente.id,
                    background : dente.layout.color,
                    class : {
                        denteLabel   : true,
                        selDente     : isNodeActive(dente),
                    }
                }"
            >                
                <div
                    v-bind="{
                        id    : dente.id + '_color',
                        style : {
                            display    : 'inline-block',
                            height     : '7px',
                            background : dente.layout.color,
                            denteAusente : !dentePresente(dente)
                        },
                        class : {
                            labelColor : true,
                            denteAusente : !dentePresente(dente)
                        }
                    }"
                ></div>
                <div 
                    v-bind="{
                        id : dente.id + '_text',
                        class : {
                            labelText : true,
                            denteAusente : !dentePresente(dente)
                        }                        
                    }"
                >                    
                    {{ dente.layout.label }}
                </div>
            </div>  
        </div>
    </div>

</template>

// =========================================================================================
// =========================================================================================

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import { gConsts } from '@/globals/gConsts';
import { nodes   } from '@/globals/nodes';

// =========================================================================================

export default {
    name : 'layerOdontogramaCMP',
    props: {
        children : Array,
        id       : String
    }, 

    // -----------------------------------------------------------------

    data () {
        return {
            gConsts : gConsts
        }
    },

    // -----------------------------------------------------------------

    computed: {  
        ...mapState([
        ]),

        tipoDenticao() {
            return this.GET_activeElem.labels[gConsts.denticao.LAYER];
        },

        // -----------------------------------------------------------------

        ...mapGetters([
            'GET_activeElem',
            'GET_usedLabels',
            'GET_dentesPresentes',
            'GET_nodesArray',
            'GET_activeLabel', 
            'GET_activeLayer',
        ]),
    },

    // -----------------------------------------------------------------

    watch: {
        // 'GET_activeLabel': function() {
        //     if (!(this.layer == this.GET_activeLayer)) {
        //         return;
        //     }

        //     this.$nextTick(function() {
        //         // faz o scroll pra label selecionado caso necessario
        //         document.getElementById('denteLabel[' + this.GET_activeLabel + ']').scrollIntoViewIfNeeded();
        //     });                
        // }
    },

    // -----------------------------------------------------------------

    methods: {
        ...mapActions([
        ]),

        // -----------------------------------------------------------------

        quadrantesArray(denticao) {
            var result = [5, 6, 1, 2, 3, 4, 7, 8];

            // switch (denticao) {
            //     case gConsts.denticao.types.DECIDUA : result = [5, 6, 7, 8]            ; break;
            //     case gConsts.denticao.types.MISTA   : result = [5, 6, 1, 2, 3, 4, 7, 8]; break;
            //     default : result = [1, 2, 3, 4];
            // }

            return result;
        },

        // -----------------------------------------------------------------

        denteInQuadrante(dente, quadrante) {
            var result = false;

            switch (quadrante) {
                case 1 : result = (dente > 10) && (dente < 20); break;
                case 2 : result = (dente > 20) && (dente < 30); break;
                case 3 : result = (dente > 40) && (dente < 50); break;
                case 4 : result = (dente > 30) && (dente < 40); break;
                case 5 : result = (dente > 50) && (dente < 56); break;
                case 6 : result = (dente > 60) && (dente < 66); break;
                case 7 : result = (dente > 80) && (dente < 86); break;
                case 8 : result = (dente > 70) && (dente < 76); break;
            }

            return result;
        },

        // -----------------------------------------------------------------
        
        handleClick(node) { 
            nodes.activateNode(node, this.GET_nodesArray); 
        },

        isNodeActive(node) { return nodes.isNodeActive(node); },

        // -----------------------------------------------------------------

        dentePresente(node) { return (this.GET_dentesPresentes.includes(node.id)); },

        // -----------------------------------------------------------------

        mounted() {            
        }
    }
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>

li {
    font-size: 0.7em;
    left: 0px;
    max-width: 95%;
    margin-top: 5px;
    text-align: left;
}

div[id^="div_labelText"] {
}

.odontograma {
    margin-top: 10px;
    margin-left: 5px;
    display : grid;
    grid-template-columns : auto auto;
    grid-row-gap: 20px;
    grid-column-gap: 20px;
    position : relative;
}

.vertical {
    border-left : 2px solid black;
    height      : 100%;
    position    : absolute;
    left        : 50%;
}

.horizontal {
    border-top : 2px solid black;
    width      : 100%;
    position   : absolute;
    top        : 50%;
}

.quadrante {
    display   : flex;    
    flex-wrap : nowrap;
}

.denteLabel {
    display: grid;
    width : 27px;
    grid-template-rows: auto 2px auto;
    grid-template-columns: auto;
    grid-template-areas:
        "labelColor"        
        "space"
        "labelText ";
    margin : 1px;
}

.labelColor {
    grid-area: labelColor;
    width: 80%;
    justify-self: center;
}

.labelText {
    grid-area: labelText;
    text-align: center;
    font-size: 0.8em;
    font-family: Verdana;
}

.denteGrid {
    display : grid;
    grid-template-rows : 2;
    grid-template-columns : repeat(16, 26px);
    grid-row-gap: 10px;
    grid-column-gap: 2px;
    :nth-child(8) {
        border-right : 3px solid black;
        margin : 10px;
    }
    :nth-child(24) {
        border-right : 3px solid black;
    }
}

.selDente {
    outline: 1px solid lightgray;
    background: lightgreen;
}

.denteAusente {
    opacity: 0.3;
}

</style>